import { AfterContentInit, ContentChild, Directive, inject, Input, TemplateRef } from "@angular/core";

import { TableComponent } from "../table/table.component";

@Directive({
	selector: "ic-table-cell",
	standalone: false,
})
export class TableCellDirective implements AfterContentInit {
	private readonly parent = inject(TableComponent);

	@Input() key: string;

	@ContentChild("headerTmpl", { static: false }) headerTemplate: TemplateRef<any>;
	@ContentChild("cellTmpl", { static: false }) cellTemplate: TemplateRef<any>;
	@ContentChild("footerTmpl", { static: false }) footerTemplate: TemplateRef<any>;

	ngAfterContentInit() {
		const template = {
			header: this.headerTemplate,
			cell: this.cellTemplate,
			footer: this.footerTemplate,
		};

		this.parent.register(this.key, template);
	}
}
